import { FC } from "react";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    display: "flex",
    width: "70%",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  valueContainer: {
    textAlign: "start",
    display: "flex",
    flexDirection: "column",
    margin: "0px 5px 0px 0px",
  },
  name: {
    backgroundColor: "white",
    margin: "3px 0px",
    padding: "5px 10px",
    fontSize: "16px",
    fontWeight: 300,
    lineHeight: "23px",
    flex: "1",
    display: "flex",
    alignItems: "center",
  },
  value: {
    fontWeight: 700,
  },
}));

const CalculatorValueContainer: FC<{
  data: any;
}> = ({ data }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={`${classes.valueContainer}`}>
        {data?.map((el, index) => (
          <div key={`name_${index}`} className={`${classes.name}`}>
            {el?.key}
          </div>
        ))}
      </div>
      <div className={`${classes.valueContainer}`}>
        {data?.map((el, index) => (
          <div key={`name_${index}`} className={`${classes.name} ${classes.value}`}>
            {el?.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalculatorValueContainer;
